import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { compose } from 'recompose';
import React, { useEffect } from 'react';
import { LandingLoginForm } from '../components/forms/LandingLoginForm';
import { i18n } from 'i18n';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import styled from 'styled-components';
import {
  expandHeightAndWidth,
  Flex,
  gridSizes,
  media,
  weights,
} from 'utils/style';

const LandingLoginComponent = ({ className }) => {
  useEffect(() => {
    const lng = getTenantPreLoginConfig().language;
    if (lng) i18n.changeLanguage(lng);
  }, []);

  return (
    <div className={`${className} public-page`}>
      <section className="main" role="main">
        <LandingLoginForm />
      </section>
    </div>
  );
};

const enhance = compose(userIsNotAuthenticatedRedir);
const StyledLandingLogin = styled(LandingLoginComponent)`
  ${Flex.column}
  ${expandHeightAndWidth()}
  color: var(--grey700);
  background-color: transparent !important;

  ${media.lessThan('extraSmall')`
    font-size: 14px;
  `};
  
  .main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 32px;
    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
    `};
  }

svg {
    margin: 0 0 64px;
    fill: var(--white);

    ${media.lessThan('extraSmall')`
      fill: var(--primary500);
      width: 94px;
      height: 26px;
      align-self: flex-start;
    `};
  }
.info {
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:first-of-type {
      margin: 64px 0 0;
    }
    a {
      color: var(--white);
      font-weight: ${weights('bold')};
      text-decoration: underline;
      font-size: ${gridSizes('M')};
      &:hover {
        filter: invert(8%);
      }
    }

    ${media.lessThan('extraSmall')`
      margin: ${gridSizes('L')} 0 0;
      &:first-of-type {
        margin: 32px 0 0;
      }
      a {
        color: var(--primary500);
        display: block;
        text-align: center;
        font-size: 14px;
        text-decoration: none;
        font-weight: ${weights('regular')};
        &:hover {
          text-decoration: underline;
        }
      }
    `};
  }
`;

const LandingLogin = enhance(StyledLandingLogin);
export { LandingLogin };
